// Public contact for the admin panel, not per-environment configuration.
export const SUPPORT_EMAIL = 'apoorv@ezymind.in';

export const supportMailto = (subject) =>
  `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}`;
